<template>
	<v-card class="elevation-0 not-found-page py-16">

		<NewsFeedEmpty
			title="Page not found at this moment."
			description="Check back later."
			centering="center"
		/>

		<v-card-actions class="justify-center">
			<v-btn
				class="not-found-page__button rounded-pill font-weight-bold py-4 px-12 text-capitalize"
				link
				to="/threads"
			>
				Go home?
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import NewsFeedEmpty from '@/components/Post/NewsFeedEmpty.vue'

export default {
	name: 'PageNotFound',
	components: { NewsFeedEmpty },
}
</script>

<style scoped lang="scss">
.not-found-page {
	&__title {
		font-family: Merriweather, sans-serif;
		font-style: normal;
		font-weight: bold;
		font-size: 30px;
		line-height: 35px;
	}

	&__button {
		color: #fff !important;
		background: rgb(65, 161, 216) !important;
		height: auto !important;
		font-size: 15px;
	}
}
</style>
